import { es, enUS } from 'date-fns/locale';
import { addYears } from 'date-fns';

export const FIXED_WEEK_COUNT = 6;
export const YEARS_RANGE_BACK = 20;
export const DEFAULT_MIN_DATE = addYears(new Date(), -YEARS_RANGE_BACK);
export const WEEK_ROW_HEIGHT = 7.69;
export const HEADER_HEIGHT = 4.31;
export const WEEKDAY_HEADER_HEIGHT = 3.38;
export const TOTAL_CALENDAR_HEIGHT =
    (WEEK_ROW_HEIGHT * FIXED_WEEK_COUNT) + HEADER_HEIGHT + WEEKDAY_HEADER_HEIGHT;

export const esSunday = {
    ...es,
    options: {
        ...es.options,
        weekStartsOn: 0,
    },
};

export const LOCALE_MAP = {
    es: esSunday,
    en: enUS,
};
